import React from "react";
import { useAuth } from "context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";
import { AppPath, UserRole, UserType } from "utils/constants";
import { hasPermission } from "utils";

export default function ProtectedRouteSP(props) {
  const { loginData } = useAuth();

  if ([UserType.NTTsp, UserType.ServiceProvider].includes(loginData.type)) {
    return <Outlet {...props} />;
  } else if (loginData.role === UserRole.Admin) {
    return <Navigate to={AppPath.UserManagement} />;
  } else if (loginData.role === UserRole.User) {
    return <Navigate to={AppPath.Location} />;
  } else if (hasPermission(loginData, UserRole.Admin, UserType.Location)) {
    return <Navigate to={AppPath.LocationUser} />;
  } else return <Navigate to={AppPath.CameraManagement} />;
}

export function ProtectedRouteSPUser(props) {
  const { loginData } = useAuth();
  if ([UserType.NTTsp, UserType.ServiceProvider].includes(loginData.type)) return <Outlet {...props} />;
  else if (loginData.role === UserRole.User) {
    return <Navigate to={AppPath.CameraManagement} />;
  } else if (loginData.role === UserRole.Admin) {
    if (loginData.type == UserType.Tenant) {
      return <Navigate to={AppPath.UserManagement} />;
    } else if (loginData.type == UserType.Location) {
      return <Navigate to={AppPath.LocationUser} />;
    }
  } 
}

export function ProtectedRouteTenant(props) {
  const { loginData } = useAuth();

  if (loginData.type == UserType.Location) return <Navigate to={AppPath.CameraManagement} />;
  else return <Outlet {...props} />;
}

export function ProtectedRouteAdmin(props) {
  const { loginData } = useAuth();
  if (loginData.type == UserType.Location) return <Navigate to={AppPath.CameraManagement} />;
  else return <Outlet {...props} />;
}

export function ProtectedRouteLocAdmin(props) {
  return <Outlet {...props} />;
  // const { loginData } = useAuth();

  // if (hasPermission(loginData, UserRole.User, UserType.Location)) {
  //   return <Navigate to={AppPath.CameraManagement} />;
  // } else if (hasPermission(loginData, UserRole.Admin, UserType.Location)) {
  //   return <Navigate to={AppPath.LocationUser} />;
  // } else return <Outlet {...props} />;
}

export function ProtectedRouteLocUser(props) {
  return <Outlet {...props} />;
  // const { loginData } = useAuth();

  // if (hasPermission(loginData, UserRole.User, UserType.Location)) {
  //   return <Navigate to={AppPath.CameraManagement} />;
  // } else return <Outlet {...props} />;
}
